export default {
      id: "info-usage",
      viewBox: "0 0 30 30",
      url: "/dist/svg/" + "sprite.svg#info-usage",
      toString: function () {
        return this.url;
      }
    }